var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[(_vm.isIconShown)?_c('i',{staticClass:"icon icon-close error__icon"}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getErrorText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }